<template>
  <div>
    <slick v-if="items.length" ref="carousel" :options="slickOptions">
      <div v-for="(item, index) in items" :key="item.id || index">
        <div :class="{ 'card-body p-0 mr-4 border rounded-lg': showBorder }">
          <div :class="{ 'shadow-none card card-box-alt': showBorder }">
            <div>
              <div class="top__right">
                <slot name="top-right" />
              </div>
              <div class="card-body d-flex justify-content-center">
                <slot name="carousel-body" :item="item" :index="index" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick';

export default {
  name: 'BaseCarousel',

  components: {
    Slick
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    showBorder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },

  computed: {
    slickOptions() {
      return {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        dots: true,
        arrow: true,
        prevArrow: '<button type="button" class="slick-prev btn__prev-slide">Previous</button>',
        nextArrow: '<button type="button" class="slick-next btn__next-slide">Next</button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1
            }
          }
        ],
        ...this.options
      };
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  max-height: 100%;
}
</style>
